/* ACTION TYPES */
export enum BRAND_KIT_EDITOR_ACTIONS {
    SET_BRAND_KIT_EDITOR_NAME = 'SET_BRAND_KIT_EDITOR_NAME',
    SET_BRAND_KIT_EDITOR_COLOR = 'SET_BRAND_KIT_EDITOR_COLOR',
    SET_BRAND_KIT_EDITOR_FONT = 'SET_BRAND_KIT_EDITOR_FONT',
    SET_BRAND_KIT_EDITOR_WATERMARK = 'SET_BRAND_KIT_EDITOR_WATERMARK',
    SET_SELECTED_BRAND_KIT = 'SET_SELECTED_BRAND_KIT',
    RESET_SELECTED_BRAND_KIT = 'RESET_SELECTED_BRAND_KIT',
    ADD_BRAND_KIT_EDITOR_COLOR = 'ADD_BRAND_KIT_EDITOR_COLOR',
    DELETE_BRAND_KIT_EDITOR_COLOR = 'DELETE_BRAND_KIT_EDITOR_COLOR',
    ADD_BRAND_KIT_EDITOR_FONT = 'ADD_BRAND_KIT_EDITOR_FONT',
    DELETE_BRAND_KIT_EDITOR_FONT = 'DELETE_BRAND_KIT_EDITOR_FONT',
    ADD_BRAND_KIT_EDITOR_WATERMARK = 'ADD_BRAND_KIT_EDITOR_WATERMARK',
    DELETE_BRAND_KIT_EDITOR_WATERMARK = 'DELETE_BRAND_KIT_EDITOR_WATERMARK',
}
